<div class="container">
  <stumpy-navigation></stumpy-navigation>
  <div class="row justify-content-center">
    <div class="col-3">
      <article>
        <div>
          <stumpy-item [itemId]="33"></stumpy-item>
          <stumpy-item [itemId]="2"></stumpy-item>
          <stumpy-item [itemId]="3"></stumpy-item>
          <stumpy-item [itemId]="29"></stumpy-item>
          <stumpy-item [itemId]="4"></stumpy-item>
          <stumpy-item [itemId]="5"></stumpy-item>
        </div>
        <div>
          <stumpy-item [itemId]="10"></stumpy-item>
          <stumpy-item [itemId]="11"></stumpy-item>
          <stumpy-item [itemId]="12"></stumpy-item>
          <stumpy-item [itemId]="13"></stumpy-item>
          <stumpy-item [itemId]="14"></stumpy-item>
          <stumpy-item [itemId]="30"></stumpy-item>
        </div>
        <div>
          <stumpy-item [itemId]="15"></stumpy-item>
          <stumpy-item [itemId]="21"></stumpy-item>
          <stumpy-item [itemId]="23"></stumpy-item>
          <stumpy-item [itemId]="24"></stumpy-item>
          <stumpy-item [itemId]="25"></stumpy-item>
          <stumpy-item [itemId]="28"></stumpy-item>
        </div>
        <div>
          <stumpy-item [itemId]="20"></stumpy-item>
          <stumpy-item [itemId]="16"></stumpy-item>
          <stumpy-item [itemId]="17"></stumpy-item>
          <stumpy-item [itemId]="18"></stumpy-item>
          <stumpy-item [itemId]="19"></stumpy-item>
          <stumpy-item [itemId]="27"></stumpy-item>
        </div>
        <div>
          <stumpy-item [itemId]="22"></stumpy-item>
          <stumpy-item [itemId]="6"></stumpy-item>
          <stumpy-item [itemId]="7"></stumpy-item>
          <stumpy-item [itemId]="8"></stumpy-item>
          <stumpy-item [itemId]="9"></stumpy-item>
          <stumpy-item [itemId]="26"></stumpy-item>
        </div>
      </article>
    </div>
    <div class="col-7">
      <stumpy-dungeons></stumpy-dungeons>
    </div>
  </div>
  <stumpy-map></stumpy-map>
</div>
